import { useMemo, useState } from "react";

import { useGetEmailRecipients } from "../apis";
import {
  EEmailEventType,
  GetEmailRecipientsParams
} from "../emailNotifications.types";

const useEmailRecipientsList = () => {
  const [eventType, setEventType] = useState<EEmailEventType | "all">("all");
  const [includeInactive, setIncludeInactive] = useState(false);

  const params: GetEmailRecipientsParams = useMemo(
    () => ({
      eventType: eventType === "all" ? undefined : eventType,
      includeInactive: includeInactive || undefined
    }),
    [eventType, includeInactive]
  );

  const { recipients, isLoading, refetch } = useGetEmailRecipients(params);

  return {
    recipients: recipients ?? [],
    isLoading,
    eventType,
    setEventType,
    includeInactive,
    setIncludeInactive,
    refetch
  };
};

export default useEmailRecipientsList;
